import { Container, Tabs, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export const View = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname.toLowerCase();
  const activeTab = path.includes("tempaltes/physical-exams")
    ? "physical-exams"
    : path.includes("tempaltes/email")
    ? "email"
    : path.includes("tempaltes/sms")
    ? "sms"
    : path.includes("tempaltes/forms")
    ? "forms"
    : path.includes("tempaltes/snippets")
    ? "snippets"
    : "physical-exams";

  return (
    <Container fluid>
      <Title mt="xl" weight={500} order={3}>
        {t("TEMPALTES")}
      </Title>
      <Tabs
        mt="xl"
        value={activeTab}
        onTabChange={(value) => {
          navigate(`${value}`);
        }}
      >
        <Tabs.List mb="xl">
          <Tabs.Tab value="physical-exams">{t("PHYSICAL_EXAMS")}</Tabs.Tab>
          {/* <Tabs.Tab value="email">{t("EMAIL")}</Tabs.Tab>
          <Tabs.Tab value="sms">{t("SMS")}</Tabs.Tab>
          <Tabs.Tab value="forms">{t("FORMS")}</Tabs.Tab>
          <Tabs.Tab value="snippets">{t("SNIPPETS")}</Tabs.Tab> */}
        </Tabs.List>
        <Outlet />
      </Tabs>
    </Container>
  );
};
